import { Container } from 'unstated'

import movieQs from './temp/movieQs.json'
import animalQs from './temp/animalQs.json'
import historyQs from './temp/historyQs.json'

import historyImgSrc from '../assets/img/history-books.jpg'
import animalsImgSrc from '../assets/img/animals.jpg'
import moviesImgSrc from '../assets/img/movies.jpg'

export default class QuestionBankStore extends Container {
  state = {
    questionBank: {
      'movie-1': {
        title: 'Movies',
        imgSrc: moviesImgSrc,
        nextAvailable: '2000-01-01',
        questions: movieQs,
      },
      'animal-1': {
        title: 'Animals',
        imgSrc: animalsImgSrc,
        nextAvailable: '2000-01-01',
        questions: animalQs,
      },
      'history-1': {
        title: 'History',
        imgSrc: historyImgSrc,
        nextAvailable: '2000-01-01',
        questions: historyQs,
      },
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/QuestionBankStore.js